import { Grid2, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";

const BackIcon = ({ redirect }: { redirect?: string }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (redirect) {
      navigate(redirect);
    } else {
      navigate(-1);
    }
    window.scrollTo(0, 0);
  };

  return (
    <Grid2>
      <IconButton onClick={handleBack}>
        <ArrowBack sx={{ color: (theme) => theme.palette.text.primary, fontWeight: 800 }} />
      </IconButton>
    </Grid2>
  );
};

export default BackIcon;
